import { Component, inject, OnInit } from '@angular/core';
import { Album } from '../../models/album.model';
import { RouterLink } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AlbumsService } from '../../services/albums.service';

@Component({
  selector: 'app-gallery',
  imports: [RouterLink, DatePipe],
  templateUrl: './gallery.component.html',
  styles: `
    .background-gradient {
      background-image: linear-gradient(rgba(4, 59, 56, 0), #043b38);
      height: 400px;
    }

    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }
  `
})
export class GalleryComponent implements OnInit {
  albums: Album[] = [];

  private albumsService = inject(AlbumsService);

  ngOnInit() {
    this.getAlbums();
  }

  getAlbums() {
    this.albumsService.getAll().subscribe({
      next: (res) => {
        this.albums = res.records;
      },
      error: (error) => {
        console.error('Error fetching albums:', error);
      }
    });
  }

  get firstAlbums() {
    if (!this.albums) {
      return [];
    }
    return this.albums.slice(0, 3);
  }
}
